var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{attrs:{"width":"620px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('BaseBodyDialog',{attrs:{"title":`THÊM ${_vm.$route.meta.title}`,"loading":_vm.loading},on:{"close":_vm.cancel,"save":_vm.save}},[_c('headFeeNewForm',{ref:"form"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }